// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pZhQ","left":"styles_left__13iH_","desktopActions":"styles_desktopActions__2tF9Z","title":"styles_title__1DSTQ"};